import { HTMLProps, JSX } from 'react'

export const ImplicitlySubmittableForm = (props: { isLoading?: boolean } & HTMLProps<HTMLFormElement>): JSX.Element => {
  const { children, isLoading, onSubmit, ...withoutChildren } = props
  return (
    <form
      {...withoutChildren}
      onSubmit={
        onSubmit
          ? (e) => {
              e.preventDefault()
              onSubmit(e)
            }
          : undefined
      }
    >
      {children}
      <input type="submit" disabled={!!isLoading} aria-hidden="true" style={{ display: 'none' }} value=" " />
    </form>
  )
}
